'use strict'

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DragSource } from 'react-dnd';


class DragAndDropSource extends React.Component {
  render() {
    const { connectDragSource, isDragging } = this.props;
    return connectDragSource(
      <div style={{opacity:isDragging ? 0.5 : 1.0, color: isDragging ? "red" : "black"}}>
        {this.props.children}
      </div>
    );
  }
}

DragAndDropSource.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired
};

var projectSource= {
  beginDrag(props) {
    // Return the data describing the dragged item
    var item = { id: props.id, position:props.position };
    return item;
  },

  endDrag(props, monitor, component) {
    if (!monitor.didDrop()) {
      return;
    }

    // When dropped on a compatible target, do something
    var item = monitor.getItem();
    var dropResult = monitor.getDropResult();
    props.prioritize(item,dropResult);
  }
};

function collect(connect, monitor) {
  return {
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDragSource: connect.dragSource(),
    // You can ask the monitor about the current drag state:
    isDragging: monitor.isDragging()
  };
}

export default DragSource('project', projectSource, collect)(DragAndDropSource);



// WEBPACK FOOTER //
// ./views/components/DragAndDropSource.jsx